import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './MinusPhraseLibraryPhrasesCell.css';

export interface MinusPhraseLibraryPhrasesCellProps {
    minusPhrases: string;
}

export class MinusPhraseLibraryPhrasesCell extends React.Component<MinusPhraseLibraryPhrasesCellProps> {
    render() {
        const { minusPhrases } = this.props;

        if (minusPhrases.length === 0) {
            return '–';
        }

        return (
            <div title={minusPhrases} className={Bem.cls('minus-phrase-library-phrases-cell')}>
                {minusPhrases}
            </div>
        );
    }
}
